<template>
  <div class="content_box">
    <div id="menuManage">
      <div class="leftTree">
        <el-tree
          node-key="id"
          ref="tree"
          :data="menuTree"
          :props="defaultProps"
          @node-click="handleNodeClick"
          default-expand-all
          v-loading="menuTreeLoading"
        ></el-tree>
      </div>
      <div class="rightCon contentPadding42" id="ManageTable">
        <div class="headTitle">
          <img src="@/assets/imgs/icon/icon_headIcon.png" alt />
          产品代码
        </div>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="产品代码" style="margin-right: 30px">
            <el-input
              v-model="searchObj.code"
              placeholder="请输入代码"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品名称" style="margin-right: 30px">
            <el-input
              v-model="searchObj.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSearch"
              class="bg5584FF formBotton"
              style="margin-left: 40px"
              >查询</el-button
            >
            <el-button type="info" @click="onReset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <hr />
        <el-button type="primary" size="small" class="bg5584FF" @click="addNew">
          <i class="el-icon-plus"></i> 新增产品
        </el-button>
        <div style="height: 20px"></div>
        <el-table
          border
          v-loading="loading"
          :data="menuList"
          style="width: 100%"
          stripe
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        >
          <el-table-column align="center" prop="code" label="产品代码">
          </el-table-column>
          <el-table-column align="center" prop="name" label="产品名称">
            <template slot-scope="scope"
              ><a
                style="color: #5582f7; cursor: pointer"
                @click="toShow(scope.row)"
                >{{ scope.row.name }}</a
              ></template
            >
          </el-table-column>
          <el-table-column
            align="center"
            prop="unit"
            label="单位"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="stat_unit"
            label="统计单位"
          ></el-table-column>
          <el-table-column align="center" prop="is_stat" label="是否统计">
            <template slot-scope="scope">{{
              scope.row.is_stat == "0" ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="stat_ratio"
            label="统计系数"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="editMenu(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="deleteMenu(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox">
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="[20, 30, 50, 100]"
            layout="sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination> -->
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total,  prev, pager, next"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 删除弹框 -->
      <el-dialog title="删除" :visible.sync="showDeleteWindow" class="delete">
        <p>确认要删除产品'{{ deleteName }}'？</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureDelete"
            >确定</el-button
          >
          <el-button type="normal" size="mini" @click="showDeleteWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 查看弹框 -->
      <el-dialog
        title="查看产品"
        :visible.sync="showWindow"
        class="dialog770 titleChange"
      >
        <el-form
          ref="editForm"
          :model="showObj"
          label-width="130px"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品代码：">
                <el-input v-model="showObj.code" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称：">
                <el-input v-model="showObj.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品简称：">
                <el-input v-model="showObj.abbreviation" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统计单位：">
                <el-input v-model="showObj.stat_unit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位：">
                <el-input v-model="showObj.unit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否统计：">
                <el-input
                  :value="showObj.is_stat === '1' ? '否' : '是'"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统计系数：">
                <el-input v-model="showObj.stat_ratio" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注：" prop="des">
                <el-input v-model="showObj.des" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑产品"
        :visible.sync="showEditWindow"
        class="dialog770 titleChange"
      >
        <el-form
          ref="editForm"
          :model="editObj"
          label-width="130px"
          size="small"
          v-loading="editLoading"
          :rules="rules"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品代码：" prop="code">
                <el-input v-model="editObj.code" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称：" prop="name">
                <el-input v-model="editObj.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品简称：" prop="abbreviation">
                <el-input v-model="editObj.abbreviation"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统计单位：" prop="stat_unit">
                <el-input v-model="editObj.stat_unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位：" prop="unit">
                <el-input v-model="editObj.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否统计：" prop="is_stat">
                <el-radio-group v-model="editObj.is_stat">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="统计系数：" prop="stat_ratio">
                <el-input v-model="editObj.stat_ratio"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：" prop="des">
                <el-input v-model="editObj.des"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureEdit"
            >提交</el-button
          >
          <el-button type="normal" size="mini" @click="showEditWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增弹框 -->
      <el-dialog
        title="新增产品"
        :visible.sync="showAddWindow"
        class="dialog770 titleChange"
      >
        <el-form
          ref="addForm"
          :model="addObj"
          label-width="130px"
          size="small"
          v-loading="addLoading"
          :rules="rules"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品代码：" prop="code">
                <el-input v-model="addObj.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称：" prop="name">
                <el-input v-model="addObj.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品简称：" prop="abbreviation">
                <el-input v-model="addObj.abbreviation"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位：" prop="unit">
                <el-input v-model="addObj.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统计单位：" prop="stat_unit">
                <el-input v-model="addObj.stat_unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否统计：" prop="is_stat">
                <el-radio-group v-model="addObj.is_stat">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="统计系数：" prop="statRatio">
                <el-input v-model="addObj.stat_ratio"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：" prop="des">
                <el-input v-model="addObj.des"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureAdd"
                >新增</el-button
              >
              <el-button
                type="normal"
                size="mini"
                @click="showAddWindow = false"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      menuTree: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      searchObj: {
        name: "",
        code: "",
      },
      menuList: [],
      editObj: {},
      addObj: {},
      showObj: {},
      deleteId: "",
      currentPage: 1,
      showDeleteWindow: false,
      showWindow: false,
      showEditWindow: false,
      showAddWindow: false,
      loading: false,
      addLoading: false,
      menuTreeLoading: false,
      editLoading: false,
      totalNum: 0,
      pageSize: 20,
      pageObj: {},
      deleteName: "",
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        code: [{ required: true, message: "请填写代码", trigger: "change" }],
        stat_unit: [
          { required: true, message: "请填写统计单位", trigger: "change" },
        ],
        unit: [{ required: true, message: "请填写单位", trigger: "change" }],
        is_stat: [
          { required: true, message: "请选择是否统计", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    onSearch() {
      this.getMenuList(1);
    },
    onReset() {
      this.searchObj = {
        name: "",
        code: "",
      };
      this.getMenuList(1);
    },
    addNew() {
      this.addObj = {
        code: "",
        name: "",
        is_stat: "0",
        unit: "",
        stat_unit: "",
        stat_ratio: "",
        des: "",
        is_delete: "0",
        abbreviation: "",
      };
      this.showAddWindow = true;
    },
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$axios
            .post("/business/dm/cp", this.addObj)
            .then(() => {
              Message.success("新增成功");
              this.addLoading = false;
              this.showAddWindow = false;
              this.getMenuList();
              this.getMenuTree();
            })
            .catch((res) => {
              this.addLoading = false;
              console.log("新增失败", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    editMenu(row) {
      this.editObj = JSON.parse(JSON.stringify(row));
      this.showEditWindow = true;
    },
    toShow(row) {
      this.showObj = JSON.parse(JSON.stringify(row));
      this.showWindow = true;
    },
    sureEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          console.log("编辑对象", this.editObj);
          this.$axios
            .put("/business/dm/cp/update", this.editObj)
            .then((res) => {
              Message.success("修改成功");
              this.editLoading = false;
              this.showEditWindow = false;
              this.getMenuList();
              this.getMenuTree();
              console.log("编辑成功", res);
            })
            .catch((res) => {
              this.editLoading = false;
              console.log("编辑错误", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    deleteMenu(row) {
      this.deleteId = row.id;
      this.deleteName = row.name;
      this.showDeleteWindow = true;
    },
    sureDelete() {
      this.$axios
        .delete("/business/dm/cp/delete/" + this.deleteId)
        .then(() => {
          Message.success("删除成功");
          this.showDeleteWindow = false;
          this.getMenuList();
          this.getMenuTree();
        })
        .catch((res) => {
          console.log("删除失败", res);
          this.showDeleteWindow = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMenuList(1);
    },
    handleCurrentChange(current) {
      this.getMenuList(current);
    },
    handleNodeClick(obj) {
      if (obj.code == "-1") {
        this.searchObj["parent_code"] = null;
      } else {
        this.searchObj["parent_code"] = obj.code;
      }
      this.getMenuList();
    },
    getNoteData(node, data) {
      data.unshift(node.data.value);
      if (node.parent !== null) {
        this.getNoteData(node.parent, data);
      }
    },
    //获取产品树
    getMenuTree() {
      this.menuTreeLoading = true;
      this.$axios
        .get("/business/dm/cp/tree")
        .then((res) => {
          this.menuTree = [
            {
              label: "产品代码",
              code: "-1",
              value: "-1",
              children: [],
            },
          ];
          console.log("产品树结果", res);
          res.data.forEach((temp) => {
            this.menuTree[0].children.push({
              label: temp.code + temp.name,
              code: temp.code,
            });
          });
          this.menuTreeLoading = false;
        })
        .catch((res) => {
          console.log("产品树获取失败", res);
          this.menuTreeLoading = false;
        });
    },
    //获取表格信息
    getMenuList(page = 1) {
      this.loading = true;
      const param = Object.assign(
        {
          page: page,
          size: this.pageSize,
        },
        this.searchObj
      );
      this.$axios
        .post("/business/dm/cp/page", param)
        .then((res) => {
          this.loading = false;
          this.menuList = res.data;
          this.totalNum = res.total;
          console.log("产品列表结果", res);
        })
        .catch((res) => {
          this.loading = false;
          console.log("产品列表错误信息", res);
        });
    },
  },
  created() {
    this.getMenuTree();
    this.getMenuList();
  },
};
</script>

<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
#menuManage {
  box-shadow: 0px 0px 50px #ccc;
  height: calc(90vh - 76px);
  display: flex;
  .leftTree {
    width: 260px;
    background-color: rgba(247, 248, 250, 1);
    box-sizing: border-box;
    padding: 20px 0px;
    height: 100%;
    overflow-y: auto;
  }
  .rightCon {
    width: calc(100% - 260px);
    height: 100%;
    overflow-y: auto;
    border-left: 1px solid rgb(220, 223, 230);
  }
  .el-cascader {
    width: 100%;
  }
}
#menuManage /deep/ .el-tree-node__children {
  .el-tree-node__label {
    padding: 2px 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }

  .el-tree-node.is-current {
    background: rgba(247, 248, 250, 1);
    & > div:first-child .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
}
#menuManage .el-tree {
  background: rgba(247, 248, 250, 1);
}
.headTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  img {
    margin-right: 24px;
    padding-left: 2px;
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 20px;
}
</style>